import { NgClass, NgTemplateOutlet } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'

import {
  AlertBodyDirective,
  AlertComponent,
  AlertTitleDirective,
} from '../../../components/alert/alert.component'
import {
  BranchProgressState,
  FailureReason,
  ProgressFailureReason,
  ValidationFailureReason,
} from '../../../models/branch.model'
import { Nl2brPipe } from '../../../pipes/nl2br.pipe'

export type ProcessErrorSizes = 'default' | 'small' | 'large'

export const USER_FACING_FAILURE_REASON = [
  'GUARDDUTY_SCAN_FAILED',
  'INVALID_FILE_EXTENSION',
  'INVALID_CONTENT_TYPE',
  'INVALID_ENCODING',
  'INVALID_CSV_FORMAT',
  'EMPTY_FILE',
  'MISSING_DATA_ROWS',
  'INCONSISTENT_COLUMNS',
  'DUPLICATE_FILE_HASH',
  'UPLOAD_VALIDATION_DATA_FAILED',
] as const satisfies FailureReason[]
export type UserFacingFailureReason =
  (typeof USER_FACING_FAILURE_REASON)[number]

@Component({
  selector: 'app-process-error',
  standalone: true,
  imports: [
    TranslatePipe,
    AlertComponent,
    AlertBodyDirective,
    AlertTitleDirective,
    NgClass,
    NgTemplateOutlet,
    Nl2brPipe,
  ],
  templateUrl: './process-error.component.html',
})
export class ProcessErrorComponent implements OnInit {
  @Input() public size: ProcessErrorSizes = 'default'
  @Input() public processState!: BranchProgressState
  @Input() public processFailureReason?: ProgressFailureReason

  public messageObject?: ValidationFailureReason

  public ngOnInit(): void {
    if (
      this.processFailureReason &&
      !USER_FACING_FAILURE_REASON.includes(
        this.processFailureReason.error as UserFacingFailureReason
      )
    ) {
      this.processFailureReason = undefined
    }

    if (typeof this.processFailureReason?.message === 'string') {
      try {
        this.messageObject = JSON.parse(this.processFailureReason?.message)
        // eslint-disable-next-line sonarjs/no-ignored-exceptions,@typescript-eslint/no-unused-vars
      } catch (err) {}
    }
  }
}
